// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3e0dy","info":"PatientInfo_info__1Vokd"};